import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { TableRow } from '@material-ui/core';

import { TableCell } from './TableCell';
import { TableHeadProps, TableHead } from './TableHead';

export const tableHeadMessagesCols = 8;

const messages = defineMessages({
  createdAt: {
    id: 'embeds.components.v2.TableHeadMessages.createdAt',
    defaultMessage: 'Date',
  },
  patient: {
    id: 'embeds.components.v2.TableHeadMessages.patient',
    defaultMessage: 'Patient',
  },
  from: {
    id: 'embeds.components.v2.TableHeadMessages.from',
    defaultMessage: 'Source',
  },
  to: {
    id: 'embeds.components.v2.TableHeadMessages.to',
    defaultMessage: 'Destination',
  },
  text: {
    id: 'embeds.components.v2.TableHeadMessages.text',
    defaultMessage: 'Message',
  },
  channel: {
    id: 'embeds.components.v2.TableHeadMessages.channel',
    defaultMessage: 'Channel',
  },
  ref: {
    id: 'embeds.components.v2.TableHeadMessages.ref',
    defaultMessage: 'Type',
  },
  status: {
    id: 'embeds.components.v2.TableHeadMessages.status',
    defaultMessage: 'Status',
  },
});

export interface TableHeadMessagesProps extends Omit<TableHeadProps, 'classes'> {}

export const TableHeadMessages: React.FC<TableHeadMessagesProps> = ({ ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <TableHead {...rest}>
      <TableRow>
        <TableCell variant="head">{formatMessage(messages.createdAt)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.patient)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.from)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.to)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.text)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.channel)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.ref)}</TableCell>
        <TableCell variant="head">{formatMessage(messages.status)}</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeadMessages;
